import React from "react";

const AboutTestimonialsSection = ({ data }) => (

    <section
        className="student-testimonials-section"
        id="testimonials"
    >

        <div className="container">

            <div className="student-section-header">

                <span className="student-eyebrow">
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    <span>{data.highlight}</span>
                </h2>

                <p>
                    {data.description}
                </p>

            </div>


            <div className="student-testimonial-grid">

                {(data.testimonials || []).map((item, i) => (

                    <article
                        className="student-testimonial-card"
                        key={i}
                    >

                        <div className="testimonial-video">

                            {item.type === "mp4" ? (

                                <video
                                    controls
                                    playsInline
                                    preload="metadata"
                                    poster={item.poster}
                                >

                                    <source
                                        src={item.url}
                                        type="video/mp4"
                                    />

                                    Your browser does not support
                                    video playback.

                                </video>

                            ) : (

                                <iframe
                                    src={item.url}
                                    title={item.title}
                                    loading="lazy"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                />

                            )}

                        </div>


                        <div className="testimonial-content">

                            <span className="testimonial-label">
                                {item.label}
                            </span>

                            <h3>
                                {item.title}
                            </h3>

                            {item.student && (
                                <p className="testimonial-student">
                                    {item.student}
                                </p>
                            )}

                            {item.location && (
                                <p className="testimonial-location">
                                    {item.location}
                                </p>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default AboutTestimonialsSection;